// Metric-filter columns use these suffixes in the dimension table renderer.
export const isSupportedSortKey = (key: string, dimension: string, metrics: string[]) =>
  key === dimension ||
  metrics.some(
    (metric) => key === metric || key === `${metric}::metric` || key === `${metric}::metricPct`,
  );
